module.exports = {"130772105":"沙沟镇","130772215":"宇宙营乡","130772401":"黄山管理处","130772402":"石门管理处","130772403":"乌兰管理处","130772404":"金沙管理处","130772405":"白塔管理处"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130772.json
// module id = 285
// module chunks = 0